// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lg-0";